import ScormController, { Scorm } from "../../../../scorm/controller/ScormController";
import SaveGameModel from "../../model/SaveGameModel";
import SavegameStrategy from "./SavegameStrategy";

export default class ScormSavegameStrategy extends SavegameStrategy {
    /**
     * @constructor
     * @param {SaveGameModel} saveGameModel 
     * @param {ScormController} scormController 
     */
    constructor(saveGameModel, scormController) {
        super(saveGameModel);

        this._scormController = scormController;
    }

    async load() {
        const savegameString = this._scormController.getValue(Scorm.SUSPEND_DATA);
        if (!savegameString) {
            this._saveGameModel.reset();
            console.log("[SaveGameService] No save game found in SCORM suspend_data");
            return;
        }

        console.log("[SaveGameService] Retrieved save game from SCORM with a length of ", savegameString.length);

        try {
            await this._saveGameModel.deserialize(savegameString);
            console.log(`[${ScormSavegameStrategy.name}] Save game loaded successfully!`);
        } catch (ex) {
            console.warn(`[${ScormSavegameStrategy.name}] Unable to load save game. Resetting save game.`, ex);
            this._saveGameModel.reset();
        }
    }

    async save() {
        try {
            const savegameString = await this._saveGameModel.serialize();
            if (savegameString.length > ScormSavegameStrategy.SCORM_SAVE_GAME_SIZE_LIMIT) {
                console.warn(`[${ScormSavegameStrategy.name}] Blocked save game functionality because the save game size is too large to be saved within this SCORM edition 'cmi.suspend_data' field.`);
                return;
            }

            const res = this._scormController.setValue(Scorm.SUSPEND_DATA, savegameString);
            console.log("[SaveGameService] Writing save game to Scorm suspend_data", res);

            // Execute a 'save' to be more sure that data is actually stored.
            const saveRes = this._scormController.save();
            console.log("[SaveGameService] Scorm Controller save", saveRes);
        } catch (ex) {
            console.warn(`[${ScormSavegameStrategy.name}] Unable to save save game.`, ex);
        }
    }

    async clear() {
        const res = this._scormController.setValue(Scorm.SUSPEND_DATA, '');
        const saveRes = this._scormController.save();
        console.log(`[${ScormSavegameStrategy.name}] Save game SCORM entry cleared.`, res, saveRes);
    }
}

ScormSavegameStrategy.SCORM_SAVE_GAME_SIZE_LIMIT = 64000; // If scorm is active and the save game size exceeds this limit, the game will not be saved.